<template>
  <div class="page-container">
    <Sidebar />
    <div class="main-content">
      <div class="page-header">
        <h1>产业链信息审核</h1>
      </div>
      
      <div class="filter-bar">
        <button :class="['filter-btn', categoryFilter === 'all' ? 'active' : '']" @click="categoryFilter = 'all'; fetchList()">全部</button>
        <button :class="['filter-btn', categoryFilter === 'seed' ? 'active' : '']" @click="categoryFilter = 'seed'; fetchList()">种子种苗</button>
        <button :class="['filter-btn', categoryFilter === 'fertilizer' ? 'active' : '']" @click="categoryFilter = 'fertilizer'; fetchList()">肥料农药</button>
        <button :class="['filter-btn', categoryFilter === 'machinery' ? 'active' : '']" @click="categoryFilter = 'machinery'; fetchList()">病虫草害</button>
        <button :class="['filter-btn', categoryFilter === 'testing' ? 'active' : '']" @click="categoryFilter = 'testing'; fetchList()">检验检测</button>
        <button :class="['filter-btn', categoryFilter === 'service' ? 'active' : '']" @click="categoryFilter = 'service'; fetchList()">技术服务</button>
        <button :class="['filter-btn', categoryFilter === 'tech' ? 'active' : '']" @click="categoryFilter = 'tech'; fetchList()">土地厂房</button>
        <button :class="['filter-btn', categoryFilter === 'equipment' ? 'active' : '']" @click="categoryFilter = 'equipment'; fetchList()">机械设备</button>
      </div>
      
      <div class="content-body">
        <div class="loading" v-if="loading">加载中...</div>
        <div class="error" v-else-if="error">{{ error }}</div>
        
        <div class="table-container" v-else>
          <table class="data-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>标题</th>
                <th>分类</th>
                <th>公司名称</th>
                <th>联系人</th>
                <th>联系电话</th>
                <th>发布者</th>
                <th>状态</th>
                <th>创建时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in list" :key="item.id">
                <td>{{ item.id }}</td>
                <td>{{ item.title }}</td>
                <td><span :class="['type-tag', item.category]">{{ item.categoryName }}</span></td>
                <td>{{ item.companyName || '-' }}</td>
                <td>{{ item.contactName }}</td>
                <td>{{ item.contactPhone }}</td>
                <td>{{ item.userName || item.userPhone || '-' }}</td>
                <td><span :class="['status-tag', item.status]">{{ getStatusName(item.status) }}</span></td>
                <td>{{ formatDate(item.createdAt) }}</td>
                <td class="actions">
                  <button class="approve-btn" v-if="item.status === 'pending'" @click="approvePost(item.id)">通过</button>
                  <button class="reject-btn" v-if="item.status === 'pending'" @click="rejectPost(item.id)">拒绝</button>
                  <button class="delete-btn" @click="deleteItem(item.id)">删除</button>
                </td>
              </tr>
              <tr v-if="list.length === 0">
                <td colspan="10" class="empty">暂无数据</td>
              </tr>
            </tbody>
          </table>
          
          <div class="pagination" v-if="totalPages > 1">
            <button :disabled="currentPage === 1" @click="changePage(currentPage - 1)">上一页</button>
            <span>{{ currentPage }} / {{ totalPages }}</span>
            <button :disabled="currentPage === totalPages" @click="changePage(currentPage + 1)">下一页</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '../components/Sidebar.vue'
import axios from 'axios'
import { getAdminPassword } from '../utils/api'

const API_BASE = '/api/admin'

export default {
  name: 'IndustryList',
  components: { Sidebar },
  data() {
    return {
      list: [],
      loading: true,
      error: '',
      categoryFilter: 'all',
      currentPage: 1,
      pageSize: 20,
      total: 0
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize)
    }
  },
  mounted() { this.fetchList() },
  methods: {
    async fetchList() {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          pageSize: this.pageSize,
          category: this.categoryFilter !== 'all' ? this.categoryFilter : undefined
        }
        const response = await axios.get(`${API_BASE}/industry-posts`, {
          params,
          headers: { 'x-admin-password': getAdminPassword() }
        })
        if (response.data.code === 200) {
          const data = response.data.data
          this.list = data.list || []
          this.total = data.total || 0
        }
      } catch (err) { this.error = '获取数据失败' }
      finally { this.loading = false }
    },
    getStatusName(status) {
      const names = { active: '已通过', pending: '待审核', deleted: '已删除' }
      return names[status] || status
    },
    formatDate(date) {
      if (!date) return '-'
      return new Date(date).toLocaleDateString('zh-CN')
    },
    changePage(page) {
      this.currentPage = page
      this.fetchList()
    },
    async approvePost(id) {
      try {
        await axios.put(`${API_BASE}/industry-posts/${id}/status`, 
          { status: 'active' },
          { headers: { 'x-admin-password': getAdminPassword() } }
        )
        this.fetchList()
      } catch (err) { alert('操作失败') }
    },
    async rejectPost(id) {
      try {
        await axios.put(`${API_BASE}/industry-posts/${id}/status`, 
          { status: 'deleted' },
          { headers: { 'x-admin-password': getAdminPassword() } }
        )
        this.fetchList()
      } catch (err) { alert('操作失败') }
    },
    async deleteItem(id) {
      if (!confirm('确定删除该信息？')) return
      try {
        await axios.delete(`${API_BASE}/industry-posts/${id}`, {
          headers: { 'x-admin-password': getAdminPassword() }
        })
        this.fetchList()
      } catch (err) { alert('删除失败') }
    }
  }
}
</script>

<style scoped>
.page-container { display: flex; min-height: 100vh; background: #f5f5f5; }
.main-content { flex: 1; margin-left: 260px; padding: 30px; }
.page-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
.page-header h1 { font-size: 24px; color: #2c3e50; }
.filter-bar { display: flex; gap: 10px; margin-bottom: 20px; flex-wrap: wrap; }
.filter-btn { padding: 8px 16px; background: white; border: 1px solid #ddd; border-radius: 5px; cursor: pointer; font-size: 13px; }
.filter-btn.active { background: #3498db; color: white; border-color: #3498db; }
.content-body { background: white; padding: 20px; border-radius: 10px; box-shadow: 0 2px 10px rgba(0,0,0,0.1); }
.loading, .error, .empty { text-align: center; padding: 50px; color: #666; }
.table-container { overflow-x: auto; }
.data-table { width: 100%; border-collapse: collapse; }
.data-table th, .data-table td { padding: 12px 15px; text-align: left; border-bottom: 1px solid #eee; }
.data-table th { background: #f8f9fa; font-weight: bold; color: #2c3e50; }
.data-table tr:hover { background: #f5f5f5; }
.type-tag { display: inline-block; padding: 2px 8px; border-radius: 3px; font-size: 12px; background: #27ae60; color: white; }
.status-tag { display: inline-block; padding: 2px 8px; border-radius: 3px; font-size: 12px; }
.status-tag.active { background: #27ae60; color: white; }
.status-tag.pending { background: #f39c12; color: white; }
.status-tag.deleted { background: #bdc3c7; color: white; }
.actions { display: flex; gap: 8px; }
.approve-btn, .reject-btn, .delete-btn { padding: 6px 12px; border: none; border-radius: 5px; cursor: pointer; font-size: 12px; }
.approve-btn { background: #27ae60; color: white; }
.reject-btn { background: #e74c3c; color: white; }
.delete-btn { background: #bdc3c7; color: #2c3e50; }
.pagination { display: flex; justify-content: center; align-items: center; gap: 15px; margin-top: 20px; }
.pagination button { padding: 8px 15px; background: white; border: 1px solid #ddd; border-radius: 5px; cursor: pointer; }
.pagination button:disabled { opacity: 0.5; cursor: not-allowed; }
</style>